'use client'

import { useState } from 'react'

const items = [
  {
    q: 'Is my data private?',
    a: 'Yes. Your recordings, notes, and calendar data are encrypted in transit and at rest. We never use your personal data to train models, and you can delete everything at any time.',
  },
  {
    q: 'Which languages does AVA understand?',
    a: 'AVA supports 30+ languages including English, Spanish, French, German, Hindi, Mandarin, Japanese, Portuguese, and more — with natural accent support.',
  },
  {
    q: 'How does the 14-day trial work?',
    a: 'Start free on Pro — no card required. After 14 days, continue free on Basic or upgrade. Your data stays, and we never auto-charge without your consent.',
  },
  {
    q: 'Can AVA join my meetings?',
    a: 'Yes — AVA records and summarizes meetings on Zoom, Google Meet, and Teams. Audio is transcribed locally when possible, with structured notes, action items, and mind maps delivered automatically.',
  },
  {
    q: 'Does it work offline?',
    a: 'Core features like voice recording, note-taking, and task capture work offline. Sync and AI summaries run as soon as you reconnect.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes. Cancel with one tap from settings. You keep all your data and can continue on the free plan indefinitely.',
  },
]

export default function FAQ() {
  const [open, setOpen] = useState(0)
  return (
    <div className="faq">
      {items.map((it, i) => {
        const active = open === i
        return (
          <div key={i} className={'faq-item' + (active ? ' open' : '')}>
            <button
              type="button"
              className="faq-row"
              onClick={() => setOpen(active ? -1 : i)}
              aria-expanded={active}
            >
              <span className="faq-q">{it.q}</span>
              <span className="faq-toggle" aria-hidden="true">
                <svg width="11" height="11" viewBox="0 0 12 12">
                  <path d="M6 1v10M1 6h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </span>
            </button>
            <div className="faq-a">
              <div className="faq-a-inner">{it.a}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
